import { $qs, $qsa } from './utils/QuerySelector';


import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import SplitText from 'gsap/SplitText';


gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// import * as THREE from 'three';
// import { Scene, PerspectiveCamera, Raycaster, Vector2, MeshBasicMaterial, RingGeometry, Mesh, WebGLRenderer, LineBasicMaterial } from 'three';
// import {Perlin, FBM} from 'three-noise';


function siteWide() {

    const customCursor = $qs('[data-name="custom-cursor"]')

gsap.set(customCursor, {xPercent: -50, yPercent: -50});

let xTo = gsap.quickTo(customCursor, "x", {duration: 0.6, ease: "power3"}),
    yTo = gsap.quickTo(customCursor, "y", {duration: 0.6, ease: "power3"});

window.addEventListener("mousemove", e => {
  // xTo(e.pageX);
  // yTo(e.pageY);
  xTo(e.clientX);
  yTo(e.clientY);
});

let scroller = ScrollSmoother.create({
    smooth: 1.5, // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true, // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  });

  const jumpTos = $qsa('[data-js="jump-to"]');

  jumpTos.forEach(item => {
    item.addEventListener('click', function(event){
      event.preventDefault();
      scroller.scrollTo(item.getAttribute("href"), true, "top top");
    })


  });

  let pinNavigation = ScrollTrigger.create({
    trigger: "body",
    pin: '[data-pin="navigation"]',
    pinSpacing: false,
    start: "top top",
    end: "bottom bottom",
    markers: false,
   
  });


  ScrollTrigger.create({
    trigger: "body",
    pin: '[data-pin="main-nav"]',
    pinSpacing: false,
    start: "top top",
    end: "bottom bottom",
    markers: false,
   
  });


  //footer menu hover animation
  const footerItems = $qsa('footer .menu-main-menu-container .menu-item a');

  footerItems.forEach(item => {

    //get text and create extra span
    const italicSpan = document.createElement('span')    
    // console.info('footer');
    // console.info(item);
    italicSpan.innerHTML = item.innerText;
    italicSpan.classList.add('inside-italic-hover');
    const initialTitle = new SplitText(item, {type: "chars", charsClass: "char"});

    item.appendChild(italicSpan);
    // const chars = splitBannerTitle.chars;
    const hoverTitle = new SplitText(italicSpan, {type: "chars", charsClass: "char"});
    const timeline = gsap.timeline({paused: true});
    timeline.to(initialTitle.chars, {opacity: 0, stagger: '0.0', duration: 0.2}, 'start')
      .to(hoverTitle.chars, {opacity: 1, stagger: '0.0', duration: 0.2},'start')

    item.addEventListener('mouseenter', (e) => {
      
      timeline.play();

    });
    item.addEventListener('mouseleave', (e) => {
      
      timeline.reverse();

    });
    
  });

  if(window.innerWidth > 1024){
  const profile = $qs("[data-name='single-team-profile']");
if(profile){
  const trigger = $qs("[data-name='single-team']");

  ScrollTrigger.create({
    trigger: trigger,
    pin: profile,
    pinSpacing: false,
    start: "top top",
    end: "bottom bottom",
    markers: false,
   
  });

}
  }
  
}

  export default siteWide;